import React from 'react';
import classnames from 'classnames';

const componentClass = 'contentPageNotFound';

const ContentNotFoundPage = ({ isProcessing }) => {
    const classes = classnames(componentClass, 'animated', 'delay-2s', 'fadeIn');
    return <article className={classes}>
        { !isProcessing ? "Uh oh, either we don't have what you are looking for or the load was fumbled?!?" : ''}
        { !isProcessing && <button className="btn btn-outline-white animated fadeIn delay-2s" onClick={() => window.location.reload()}>Reload Page</button> }
    </article> ;
};

export default ContentNotFoundPage;
